
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-readonly-demo-base","pages-pages-reference-readonly-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?type=demo')
};